export default {
  methods: {
    getPDFTheme() {
      if( this.config.pdf_style ) {
        return this.config.pdf_style;
      }

      if (this.config.theme === 'fsoel') {
        return 'fsoel';
      } else if (this.config.theme === 'vrnet') {
        return 'vrnet';
      } else if (this.config.theme === 'spv') {
        return 'spv';
      } else if (this.config.theme === 'slv') {
        return 'slv';
      } else {
        return 'vkb';
      }
    },
    getPDFName(fileName) {
      let pdfTheme = this.getPDFTheme();
      if(pdfTheme === 'fsoel') {
        return 'Feuersoziataet-' + fileName;
      } else if (pdfTheme == 'vkb' || pdfTheme == 'vrnet') {
        return 'Versicherungskammer-Bayern-' + fileName;
      }
      return fileName;
    },
    getApiDataSource() {
      if( this.config.api_data_source ) {
        return this.config.api_data_source;
      }

      if (this.config.theme === 'vkb' || this.config.theme === 'vrnet') {
        return 'vkb';
      } else if (this.config.theme === 'fsoel') {
        return 'fsoel';
      }
      return 'vkb';
    }
  }
};


// WEBPACK FOOTER //
// ./src/mixins/themeHandler.js